module.exports = __webpack_public_path__ + "img/loginHeader.2726398d.svg";